const branding = import.meta.env.VITE_APP_BRANDING as unknown as string;

const brands = new Map < string, any>();
const isMobile = import.meta.env.VITE_APP_IS_MOBILE == 'true';


brands.set("orange", {
    id: "orange",
    label: "ta-zeitblick",
    name: "TA Zeitblick",
    legalEntity: "Software 1 GmbH",
    url: "ta-zeitblick.de",
    colors: {
        primary: '#F7941D',
        success: '#28C76F',
        danger: '#EA5455',
        warning: '#FF9F43',
        dark: '#1E1E1E',
    },
    links: {
        imprint: "internal",
    },
    isMobile: isMobile,
    supportPhone: '+49 1806 456326',
    supportPhoneFootnote: 'Mo-Do 7 – 17 Uhr, Fr 7 - 16 Uhr, 20 Cent aus dem deutschen Festnetz, Mobilfunkpreise können abweichen, maximal jedoch 60 Cent pro Anruf',
    ios: "https://apps.apple.com/de/app/ta-zeitblick/id1439069958",
    android: "https://play.google.com/store/apps/details?id=com.zeitstrom.ta_mobile",
    smallLogoWidth: 38,
});

brands.set("black", {
    id: "black",
    label: "utax-zeitblick",
    name: "UTAX Zeitblick",
    legalEntity: "Software 1 GmbH",
    url: "utax-zeitblick.de",
    colors: {
        primary: '#F7941D',
        success: '#28C76F',
        danger: '#EA5455',
        warning: '#FF9F43',
        dark: '#1E1E1E',
    },
    links: {
        imprint: "internal",
    },
    isMobile: isMobile,
    // supportPhone: '+49 1806 456326',
    // supportPhoneFootnote: 'Mo-Do 7 – 17 Uhr, Fr 7 - 16 Uhr, 20 Cent aus dem deutschen Festnetz, Mobilfunkpreise können abweichen, maximal jedoch 60 Cent pro Anruf',
    ios: "https://apps.apple.com/de/app/utax-zeitblick/id1561923176",
    android: "https://play.google.com/store/apps/details?id=com.zeitstrom.utax_mobile",
    smallLogoWidth: 38,
});

brands.set("red", {
    id: "red",
    label: "zeitstrom",
    name: "Zeitstrom",
    legalEntity: "Software 1 GmbH",
    url: "app.zeitstrom.com",
    colors: {
        primary: '#DF4D44',
        success: '#28C76F',
        danger: '#EA5455',
        warning: '#FF9F43',
        dark: '#1E1E1E',
    },
    links: {
        imprint: "https://www.zeitstrom.com/impressum/",
        privacyPolicy: "https://www.zeitstrom.com/datenschutz/",
        terms: "https://www.zeitstrom.com/agb/",
    },
    isMobile: isMobile,
    // supportPhone: '+49 1806 456326',
    // supportPhoneFootnote: 'Mo-Do 7 – 17 Uhr, Fr 7 - 16 Uhr, 20 Cent aus dem deutschen Festnetz, Mobilfunkpreise können abweichen, maximal jedoch 60 Cent pro Anruf',
    supportPhone: undefined,
    supportPhoneFootnote: undefined,
    ios: "https://apps.apple.com/de/app/zeitstrom/id1556863270",
    android: "https://play.google.com/store/apps/details?id=com.zeitstrom.zs_mobile",
    smallLogoWidth: 38,
});

brands.set("blue", {
    id: "blue",
    darkModeOnly: true,
    label: "timesec",
    name: "TimeSec",
    legalEntity: "TimeSec Zeitmanagement GmbH",
    url: "app.timesec.eu",
    colors: {
        primary: '#EAB308',
        success: '#22C55E',
        danger: '#EA5455',
        warning: '#EF44',
        dark: '#1F2937',
        darkHeaderBackground: '#374151',
        lightHeaderBackground: '#ffffff',
    },
    links: {
        imprint: "https://www.timesec.de/impressum",
    },
    isMobile: isMobile,
    // supportPhone: '+49 1806 456326',
    // supportPhoneFootnote: 'Mo-Do 7 – 17 Uhr, Fr 7 - 16 Uhr, 20 Cent aus dem deutschen Festnetz, Mobilfunkpreise können abweichen, maximal jedoch 60 Cent pro Anruf',
    supportPhone: undefined,
    supportPhoneFootnote: undefined,
    ios: "https://apps.apple.com/de/app/zeitstrom/id1556863270",
    android: "https://play.google.com/store/apps/details?id=com.zeitstrom.zs_mobile",
    smallLogoWidth: 32,
});

brands.set("zinc", {
    id: "zinc",
    label: "zeit",
    name: "Zeit Management",
    legalEntity: "Software 1 GmbH",
    url: "app.zeit.work",
    colors: {
        primary: '#71727C',
        success: '#22C55E',
        danger: '#EA5455',
        warning: '#EF44',
        dark: '#1F2937',
        darkHeaderBackground: '#374151',
        lightHeaderBackground: '#ffffff',
    },
    links: {
        imprint: "internal",
        // privacyPolicy: "https://zeitstrom.com/privacy-policy/",
    },
    isMobile: isMobile,
    supportPhone: '+49 1806 456326',
    supportPhoneFootnote: 'Mo-Do 7 – 17 Uhr, Fr 7 - 16 Uhr, 20 Cent aus dem deutschen Festnetz, Mobilfunkpreise können abweichen, maximal jedoch 60 Cent pro Anruf',
    ios: "https://apps.apple.com/de/app/utax-zeitblick/id1561923176",
    android: "https://play.google.com/store/apps/details?id=com.zeitstrom.utax_mobile",
    smallLogoWidth: 38,
});

const defaultBrand = brands.get(branding || 'red');

function getDefaultBrand() {
    const localDefaultBrandId = JSON.parse(localStorage.localSettings || '{}')['default_brand'];
    if (localDefaultBrandId) return brands.get(localDefaultBrandId);

    return defaultBrand;
}


function getBrandByLabel(label?: string): any {
    if (!label) return getDefaultBrand();

    for (const brand of brands.values()) {
        if (brand.label == label) return brand;
    }

    return getDefaultBrand();
}


export default defaultBrand;

export { getBrandByLabel, brands }
